import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabItemComponent } from './tab-item/tab-item.component';
import { TabsComponent } from './tabs/tabs.component';



@NgModule({
  declarations: [TabsComponent, TabItemComponent],
  imports: [
    CommonModule
  ],
  exports:  [TabsComponent, TabItemComponent]
})
export class TabsModule { }
